import { render, staticRenderFns } from "./offline-activity-list.vue?vue&type=template&id=2436e10c&scoped=true&"
import script from "./offline-activity-list.vue?vue&type=script&lang=js&"
export * from "./offline-activity-list.vue?vue&type=script&lang=js&"
import style0 from "./offline-activity-list.vue?vue&type=style&index=0&id=2436e10c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2436e10c",
  null
  
)

export default component.exports